import "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"
import "select2/dist/js/i18n/he"
import "select2/dist/js/i18n/ru"
import "select2/dist/js/i18n/en"

/**
 * Newly loaded document or node.
 * @param context
 */
export default context => {

    $('[data-il-autocomplete]:not(.processed)', context).each(function () {
        const container = $(this)
        container.addClass('processed')
        const options = container.data('il-autocomplete')
        const streetInput = container.find('[data-role="street"]')
        const houseInput = container.find('[data-role="house"]')
        const entranceInput = container.find('[data-role="entrance"]')
        const rawInput = container.find('[data-role="raw"]')
        const aptInput = container.find('[data-role="apartment"]')
        const cityInput = container.find('[data-role="city"]')
        const countryInput = container.find('[data-role="country"]')
        const postalInput = container.find('[data-role="postal"]')
        const neighborInput = container.find('[data-role="neighborhood"]')
        const fullInput = container.find('[data-role="full"]')

        const getRaw = () => {
            try {
                return JSON.parse(rawInput.val())
            } catch {
                return {}
            }
        }
        const setRaw = data => {
            rawInput.val(JSON.stringify(data))
        }
        const updateRaw = (values) => {
            let data = getRaw()
            for (const [key, val] of Object.entries(values)) {
                data[key] = val
            }
            setRaw(data)
        }
        const simpleUpdate = function () {
            let data = getRaw()
            data[$(this).data('role')] = $(this).val()
            setRaw(data)
        }

        streetInput.select2({
            theme: 'bootstrap',
            dropdownParent: container.closest('.modal-body,.bootstrap-isolated'),
            placeholder: 'Select Street',
            allowClear: true,
            ajax: {
                url: '/site/find-street',
                delay: 300,
                data: params => {
                    return {
                        city: getRaw().cityId,
                        filter: params.term,
                    }
                },
                dataType: 'json',
                processResults: data => {
                    let result = []
                    for (const [key, entry] of Object.entries(data)) {
                        result.push({id: entry.streetId, text: entry.streetName})
                    }
                    return {
                        results: result
                    }
                },
                cache: true,
            },
            minimumInputLength: 3,
        }).on('select2:select', async e => {
            const item = e.params.data
            updateRaw({streetId: item.id, streetName: item.text})
            houseInput.val(null).trigger('change')
            neighborInput.val(null).trigger('change').attr('readonly', false)
        }).on('select2:clear', e => {
            updateRaw({streetId: '', streetName: ''})
            houseInput.val(null).trigger('change')
            neighborInput.val(null).trigger('change').attr('readonly', false)
        })

        houseInput.select2({
            theme: 'bootstrap',
            allowClear: true,
            placeholder: 'House number',
            dropdownParent: container.closest('.modal-body,.bootstrap-isolated'),
            ajax: {
                url: '/site/find-house',
                data: params => {
                    return {
                        city: getRaw().cityId,
                        street: getRaw().streetId,
                        filter: params.term,
                    }
                },
                dataType: 'json',
                processResults: data => {
                    return {
                        results: data.map(val => {
                            return {id: val, text: val}
                        })
                    }
                },
                cache: true,
            },
            minimumInputLength: 0,
            language: {
                errorLoading: function () {
                    return "No data.";
                }
            }
        }).on('select2:select', async e => {
            const item = e.params.data
            updateRaw({houseId: item.id, houseName: item.text})
            const neighbors = await $.get('/site/find-neighborhood', {
                city: getRaw().cityId,
                street: getRaw().streetId,
                house: item.id,
            })
            neighborInput.val(neighbors[0] || '').trigger('change')
            neighborInput.attr('readonly', !!neighborInput.val())

        }).on('select2:clear', e => {
            updateRaw({houseNum: ''})
            neighborInput.val('').trigger('change')
            neighborInput.attr('readonly', false)
        })

        entranceInput.on('change', simpleUpdate)
        aptInput.on('change', simpleUpdate)
        cityInput.on('change', simpleUpdate)
        countryInput.on('change', simpleUpdate)
        neighborInput.on('change', simpleUpdate)
        postalInput.on('change', simpleUpdate)

        // Default values.
        let raw = getRaw()
        if (typeof raw !== 'object' || raw === null) {
            raw = {}
        }

        setRaw({
            full: raw.full || '',
            streetId: raw.streetId || '',
            streetName: raw.streetName || '',
            houseId: raw.houseId || raw.houseNum || '',
            houseName: raw.houseName || raw.houseNum || '',
            entrance: raw.entrance || '',
            apartment: raw.apartment || '',
            cityId: raw.cityId || options.cityId,
            city: raw.city || '',
            country: raw.country || '',
            postal: raw.postal || '',
            neighborhood: raw.neighborhood || '',
        })
        raw = getRaw();
        [fullInput, neighborInput, countryInput, cityInput, streetInput, houseInput, entranceInput, aptInput, postalInput]
            .forEach(function (e) {
                const fieldName = e.data('role')
                if (e.hasClass('select2-hidden-accessible')) {
                    e.append(new Option(raw[fieldName + 'Name'], raw[fieldName + 'Id']), false, true)
                } else {
                    // normal
                    e.val(raw[fieldName])
                }
                e.trigger('change')
            })
        if (streetInput.length > 0 && houseInput.length > 0)  {
            neighborInput.attr('readonly', !!neighborInput.val())
        }
    })
}
